module.exports = __webpack_public_path__ + "static/img/生物師資介紹.64f83ca1.png";